import { FovLoader, FovOption, FovSelect, SearchInputField } from 'components';
import { Fragment, useEffect, useMemo, useRef } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useCookies } from 'react-cookie';
import { useDispatch, useSelector } from 'react-redux';
import { getModelsAdmin, clearAdminModels } from 'store/actions/admin';
import { withTheme } from 'styled-components';
import { HeaderContainer, MemberContainer, SortContainer } from 'pages/ArchVisionAdminDashboard/styles';
import { modelListColumns } from './listColumns';

export const CreatorModels = withTheme(props => {
    const { theme } = props;
    const dispatch = useDispatch();

    const userDataStore = useSelector(state => state.userData);
    const adminDataStore = useSelector(state => state.adminData);
    const searchFieldRef = useRef('');

    const [ cookies ] = useCookies([ 'userAuth' ]);
    const token = cookies.archvision_token;

    const selectedTheme = userDataStore.userPreferences.theme;
    const models = useMemo(() => adminDataStore.models, [ adminDataStore.models ]);
    const isLoading = useMemo(() => adminDataStore.isLoading, [ adminDataStore.isLoading ]);
    const pagination = useMemo(() => adminDataStore.pagination, [ adminDataStore.pagination ]);
    const { page, pageSize, totalCount } = pagination;

    const [ searchParams, setSearchParams ] = useSearchParams();

    const handlePageChange = page => {
        if (Number(searchParams.get('page')) === page) return;
        searchParams.set('page', page);
        setSearchParams(searchParams);
        dispatch(getModelsAdmin(token));
    };

    const handleBlur = () => {
        const value = searchFieldRef.current.value;

        if (value === '') {
            searchParams.delete('search');
            searchParams.set('page', 1);
            setSearchParams(searchParams);
            dispatch(getModelsAdmin(token));
            return;
        }

        searchParams.set('search', value);
        searchParams.set('page', 1);
        setSearchParams(searchParams);
        dispatch(getModelsAdmin(token));
    };

    useEffect(() => {
        return () => { dispatch(clearAdminModels()); };
    }, []);

    const sortOptions = [
        { key: 'TITLE_ASC', text: 'Title (A-Z)', orderKey: 'order_by' },
        { key: 'TITLE_DESC', text: 'Title (Z-A)', orderKey: 'order_by' },
        { key: 'CATEGORY_ASC', text: 'Category (A-Z)', orderKey: 'order_by' },
        { key: 'CATEGORY_DESC', text: 'Category (Z-A)', orderKey: 'order_by' },
        { key: 'CREATED_OLD_TO_NEW', text: 'Creation Date ↑', orderKey: 'order_by' },
        { key: 'CREATED_NEW_TO_OLD', text: 'Creation Date ↓', orderKey: 'order_by' },
        { key: 'UPDATED_OLD_TO_NEW', text: 'Date Updated ↑', orderKey: 'order_by' },
        { key: 'UPDATED_NEW_TO_OLD', text: 'Date Updated ↓', orderKey: 'order_by' },
    ];
    const buildSortOptions = () => sortOptions.map(option => (
        <FovOption key={option.key} value={option.key}>
            {option.text}
        </FovOption>
    ));

    const selectedSortOption = sortOptions.find(opt => {
        return searchParams.get('order_by') === opt.key;
    });

    return (
        <FovLoader
            text='Retrieving Models'
            resource={!isLoading}
        >
            {models?.length === 0 && <div>No Models.</div>}
            {models?.length > 0 &&
                <Fragment>
                    <HeaderContainer>
                        <SearchInputField
                            width={400}
                            disabled={false}
                            ref={searchFieldRef}
                            defaultValue={searchFieldRef.current?.value || searchParams.get('search')}
                            onChange={e => searchFieldRef.current.value = e.target.value}
                            onKeyUp={e => e.key === 'Enter' && e.target.blur()}
                            onBlur={handleBlur}
                        />
                        <SortContainer>
                            <FovSelect
                                value={selectedSortOption?.key || ''}
                                placeholder={'Sort by'}
                                onChange={(e,newVal) => {
                                    const sortOption = sortOptions.find(opt => opt.key === newVal);
                                    searchParams.delete('order_by');
                                    searchParams.set(sortOption.orderKey, sortOption.key);
                                    searchParams.set('page', 1);
                                    setSearchParams(searchParams);
                                    dispatch(getModelsAdmin(token));
                                }}
                            >
                                {buildSortOptions()}
                            </FovSelect>
                        </SortContainer>
                    </HeaderContainer>
                    <MemberContainer
                        dataSource={models}
                        $selectedTheme={selectedTheme}
                        columns={modelListColumns(theme, selectedTheme)}
                        rowKey={'row-' + Math.random()}
                        currentPage={page}
                        pageSize={pageSize}
                        totalCount={totalCount}
                        isPagination={true}
                        selectedKey='rpc_guid'
                        onPageChange={handlePageChange}
                    />
                </Fragment>
            }
        </FovLoader>
    );
});